"use client";
import { useCallback, useEffect, useId, useState } from 'react';
import styles from "./MailchimpSignupForm.module.css";



//#region [Props]
type MailChimpSignupFormProps = {
    value: {
        signupForm: string;
        gdprFormId: number;
    };
};
//#endregion


//#region [Component]
export default function MailChimpSignupForm({ value }: MailChimpSignupFormProps) {
    const [hasAcceptedTc, setHasAcceptedTc] = useState(false);
    const [showTcError, setShowTcError] = useState(false);
    const formId = useId();

    const onSubmit = useCallback((event: SubmitEvent) => {
        event.preventDefault();
        if (!hasAcceptedTc) {
            setShowTcError(true);
        } else {
            const form = document.querySelector(`#${formId.replaceAll(':', 'X')} form`) as HTMLFormElement;
            form.submit();
            setShowTcError(false);
            console.log("Form submitted");
        }

    }, [hasAcceptedTc, formId]);

    useEffect(() => {
        const form = document.querySelector(`#${formId.replaceAll(':', 'X')} form`) as HTMLFormElement;
        if (form) {
            form.addEventListener("submit", onSubmit);
        }
        return () => {
            form?.removeEventListener("submit", onSubmit);
        };

    }, [onSubmit, formId]);



    return (<div id={formId.replaceAll(':', 'X')}>
        <div className={styles.SSignupForm} dangerouslySetInnerHTML={{ __html: value.signupForm }}></div>
        <div>
            <label className={styles.SLabel} htmlFor="personvernCheckbox0">
                <input id="personvernCheckbox0" name="personvernCheckbox0" type="checkbox" checked={hasAcceptedTc} onChange={() => setHasAcceptedTc(!hasAcceptedTc)} /> Godta <a href={`https://forms.filmweb.no/form/displayform?id=${value.gdprFormId}`} target="_blank" rel="noreferrer">personvernerklæringen</a>
            </label>
            {showTcError && <div className={styles.STermsError}>Du må godta personvernerklæringen</div>}
        </div>
    </div>);
}
//#endregion